var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0186 8.83008C18.0186 13.6453 14.1151 17.5488 9.2998 17.5488C4.48456 17.5488 0.581055 13.6453 0.581055 8.83008C0.581055 4.01483 4.48456 0.111328 9.2998 0.111328C14.1151 0.111328 18.0186 4.01483 18.0186 8.83008ZM8.29131 13.4466L14.7601 6.97784C14.9797 6.75818 14.9797 6.40201 14.7601 6.18236L13.9646 5.38688C13.7449 5.16718 13.3888 5.16718 13.1691 5.38688L7.89355 10.6624L5.43054 8.19934C5.21089 7.97968 4.85472 7.97968 4.63503 8.19934L3.83955 8.99482C3.61989 9.21448 3.61989 9.57064 3.83955 9.7903L7.4958 13.4466C7.71549 13.6662 8.07162 13.6662 8.29131 13.4466Z",
    fill: "#36BFFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.de7335c7dc50ceab47b4e160325f42cc.svg";
export { ForwardRef as ReactComponent };